import { observer, inject } from "mobx-react";
import React, { Component } from "react";
import { IntlProvider } from "react-intl";
import { Route, Switch } from "react-router-dom";
import "./App.scss";
import AdminReports from "./components/AdminReports";
import Animator from "./components/Animator";
import { AuthGate } from "./components/Auth";
import Details from "./components/Details";
import Home from "./components/Home";
import Loader from "./components/Loader";
import LoginPage from "./components/LoginPage";
import NotFound from "./components/NotFound";
import en from "./dictionary/en.json";
import { MainStore } from "./stores/MainStore";

interface AppProps {
  store?: MainStore;
}
@observer
class App extends Component<AppProps> {

  render() {

    const { store } = this.props;

    if (!store) return null;
    /// DON'T REMOVE 2 NEXT LINES
    // eslint-disable-next-line  @typescript-eslint/no-unused-vars
    const { loading, selectedState, router } = store;
    return (
      <IntlProvider locale="en" messages={en}>
        <AuthGate>
          {({ user }) =>
            user ? (
              <div className="App">
                <Loader store={store} />
                <Switch>
                  <Route
                    path="/"
                    exact
                    render={props => (
                      <Home {...props} store={store} />
                    )}
                  />
                  <Route
                    path="/country/:id"
                    exact
                    render={props => (
                      <Home {...props} store={store} />
                    )}
                  />
                  <Route
                    path="/continent/:id"
                    exact
                    render={props => (
                      <Home {...props} store={store} />
                    )}
                  />
                  <Route
                    exact
                    path="/details/country/:id"
                    render={props => (
                      <Details {...props} store={store} />
                    )}
                  />
                  <Route
                    exact
                    path="/admin/reports"
                    render={props => (
                      <AdminReports {...props} store={store} />
                    )}
                  />
                  <Route
                    render={props => (
                      <NotFound {...props} store={store} />
                    )}
                  />
                </Switch>
                <Animator store={store} />
              </div>
            ) : (
                <LoginPage store={store} />
              )
          }
        </AuthGate>
      </IntlProvider>
    );
  }
}

export default inject("store")(observer(App));
